class ErrorMessageResolver {
  isCustomsErrorMessage(errorMessage) {
    if (!errorMessage) {
      return false;
    }

    const customsMatchRegex = /\w*customs*\w/gi;
    return customsMatchRegex.test(errorMessage);
  }
}

export default new ErrorMessageResolver();
